// A child added to the occupancy has no age until the guest picks one. Until then its slot holds
// UNSELECTED_CHILD_AGE, so that "not answered yet" stays distinguishable from "0 years old" - 0 is a
// real age a guest can pick
export const UNSELECTED_CHILD_AGE = null

export const UNSELECTED_CHILD_AGE_URL_VALUE = 'x'

export const isChildAgeUnselected = age => age === null || age === undefined

export const hasUnselectedChildAge = childrenAges =>
  Array.isArray(childrenAges) && childrenAges.some(isChildAgeUnselected)

// The availability API takes integer ages only, so unselected slots travel as 0. Only the count
// matters there - the guest still has to pick every age before a unit can be selected.
export const childrenAgesForRequest = childrenAges =>
  Array.isArray(childrenAges) ? childrenAges.map(age => (isChildAgeUnselected(age) ? 0 : age)) : childrenAges

export const childrenAgesForUrl = childrenAges =>
  Array.isArray(childrenAges)
    ? childrenAges.map(age => (isChildAgeUnselected(age) ? UNSELECTED_CHILD_AGE_URL_VALUE : age))
    : childrenAges

export const restoreUnselectedChildAges = (childrenAges, search) => {
  const urlChildren = new URLSearchParams(search).get('children')

  if (!Array.isArray(childrenAges) || !urlChildren) {
    return childrenAges
  }

  const urlAges = urlChildren.split(',')

  if (urlAges.length !== childrenAges.length) {
    return childrenAges
  }

  return childrenAges.map((age, i) => (urlAges[i] === UNSELECTED_CHILD_AGE_URL_VALUE ? UNSELECTED_CHILD_AGE : age))
}
